<template>
    <div>
        <setCode ref="set_code" :rules="rules" v-on:set_code="make_set_code"/>

        <main_table v-if="rules_visible != null" :attrs="fields" :elements="rules_visible" v-on:apply_filters="filter">
    
            <template v-slot:nav_start>
                <b-navbar-brand>
    
                    <h4>Правила кодирования</h4>
    
                </b-navbar-brand>
            </template>
    
            <template v-slot:nav_end>
                <b-nav pills>

					<b-form-input size="sm" v-model="query" v-on:input="filter" placeholder="Поиск" style="width: 200px; height: 38px"/>

                    <!-- <b-button v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" title="Фильтр" v-on:click="filter">
                        <div :style="filter_button_colored ? 'color: green !important;' : ''">
                            <base-icon name="filter_alt" />
                        </div>                    
                    </b-button> -->
                    <b-button v-if="!not_editable && check_roles([ 'group_tree' ])" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary"
                        title="Множественное присвоение кода"
                        @click="() => set_code()"
                    >
                        <base-icon name="pen" />
                    </b-button>
                </b-nav>
    
            </template>
    
            <template v-slot:table_cell_params="cell_data">
                <!-- <input_integer v-if="cell_data.data.field.key == 'code' && !not_editable && show_inputs && check_roles([ 'group_tree' ])" :value="cell_data.data.item.code"
					v-on:change="value => change(cell_data.data.item.id, cell_data.data.item.raw_value, value == null ? null : Number(value))" /> -->
                <table_input v-if="cell_data.data.field.key == 'code' && !not_editable && show_inputs && check_roles([ 'group_tree' ])"
                    :value="cell_data.data.item.code" :item="cell_data.data.item"
                    v-on:change="value => change(cell_data.data.item.id, cell_data.data.item.raw_value, value)"
                    :validation="code_validation" is_not_required
                />
				<span v-else-if="cell_data.data.value == null || cell_data.data.value == 'null'">Пусто</span>
				<span v-else>{{ cell_data.data.value }}</span>
            </template>
    
        </main_table>
    </div>
</template>

<script>

import api from "../../../../api"
import main_table from '../../../widgets/main_table'
// import input_integer from "../../../widgets/input_integer"
import table_input from "../../../widgets/table_input"
import setCode from './set_code'

export default {
    props :
    {
		attr : Object,
        raw_rules : Object,
        not_editable : Boolean,
    },

    components :
    {
        main_table,
        setCode,
		// input_integer,
        table_input
    },

    data()
    {
        return {

			query : null,
			rules : [],
			rules_visible : null,
			show_inputs : true,

            fields :
            [
                { key : 'value', label : 'Обобщенное значение', thStyle : 'width : 35%', },
                { key : 'code', label : 'Код', thStyle : 'width : 35%', },
                { key : 'count_objects', label : 'Количество ОО', thStyle : 'width : 15%', },
                { key : 'count_analogues', label : 'Количество ОА', thStyle : 'width : 15%', },
            ],

            filter_button_colored : false,
            code_validation : {
                check : (value) => api.check_number({ value : value, accuracy : 0, gte : 0 }),
                msg : "Целое положительное число"
            }
        }
    },

	watch :
	{
		raw_rules :
		{
			immediate : true,
			deep : true,

			handler(raw_rules)
			{
				if(raw_rules)
				{
					var rules = []

					Object.keys(raw_rules).forEach(e => {
						rules.push({ raw_value : e, value : raw_rules[e].label, code : raw_rules[e].code, id : raw_rules[e].id, count_objects : raw_rules[e].count_objects, count_analogues : this.raw_rules[e].count_analogues })
					})

					this.rules = rules

					this.filter()
				}
			}
        }
    },

    methods :
    {
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		change(id, value, code)
        {
            this.$emit('set_new_rule', id, value, code)
        },

        set_code()
        {
            this.$refs.set_code.execute()
		},

		filter()
		{
			if(this.query && this.query.length > 0)
			{
				const exp = new RegExp(this.query, "i")

				this.rules_visible = this.rules.filter(elem => ( ( elem.value != null && elem.value.match(exp) ) || ( elem.code != null && elem.code.toString().match(exp) ) ) )
			}
			else
				this.rules_visible = this.rules

			this.show_inputs = false

			this.$nextTick(() => { this.show_inputs = true })
		},

		make_set_code(code)
		{
			var values = []

			this.rules_visible.forEach(rule => values.push(rule.value))

			this.$emit("set_new_rule_many", values, code)
		},
    }
}
</script>
